import React, { useEffect, useState } from 'react';
import { getData } from '../../helpers/indexedDbHelper';
import { useRefresh } from '../../hooks/useRefresh';
import LayoutContent from '../../components/layouts/content2';
import { useTranslation } from 'react-i18next';
import HomeScreen from './home';
import BuffetScreen from './buffet';
import CumpleScreen from './cumple';


function Index() {

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const {change} = useRefresh();
    const [menus, setMenus] = useState([]);

    const [showHome, setShowHome] = useState(false);
    const [showBuffet, setShowBuffet] = useState(false);
    const [showCumple, setShowCumple] = useState(false);

    const [showListProduct, setShowListProduct] = useState(false);
    const [showSpecials, setShowSpecials] = useState(false);
    const [showCategories, setshowCategories] = useState(false);
    const [showHappy, setShowHappy] = useState(false);
    const [showExecutiveMenu, SetshowExecutiveMenu] = useState(false);
    const [showBar, setShowBar] = useState(false);
    const [dishs, setdishs] = useState(false);
    const [dataFood, setDataFood] = useState(false);


    useEffect(() => {
        getData('menu').then((items) => {
            const data = items.value.data;

            setMenus(data);
        });
    }, [change]);



      useEffect(() => {
              menus.map((item) => {
                  if (item.id === 435) {
                  setDataFood(item);
                  }


              });
      }, [menus]);


    useEffect(() => {
        const handleVisibilityChange = () => {
        if (document.visibilityState === "hidden") {
            console.log("La página ha perdido el foco (está oculta).");
            setShowHome(false)

        } else if (document.visibilityState === "visible") {
            console.log("La página está en foco (visible).");
        }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        // Limpieza del evento al desmontar el componente
        return () => {
        document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, []);



    window.onerror = function () {
        console.log('Error global detectado, recargando...');
        setTimeout(() => {
            window.location.reload();
        }, 2000);
        };


    return (

        <LayoutContent showLamp={false}showLogo={false} showFooter={false} showBack={false} showImageTop={false} setShowSpecials={setShowSpecials} goCategories={setshowCategories}>
            <div style={{ position: 'fixed', inset: 0, zIndex: 1 }}>

                <div onClick={() => setShowHome(true)} style={{ position: 'absolute', inset: 0, marginTop: 20 }}>
                    <img
                        onContextMenu={(e) => e.preventDefault()}
                        src={require('./assets/fullhome.jpeg')}
                        loop autoPlay={true} muted
                        style={{
                            width: '100%',
                            height: 860,
                            pointerEvents: 'none',
                            objectFit: 'contain',
                        }}
                    />
                </div>

                <div onClick={() => setShowHome(true)} style={{ position: 'absolute', bottom: 10, left: 0, right: 0, display: 'flex', zIndex: 100, paddingInline: 20, boxSizing: 'border-box' }}>
                    <img onContextMenu={(e) => e.preventDefault()}
                        src={require('./assets/tapwel2.png')}
                        style={{
                            width: '100%',
                            height: 100,
                            pointerEvents: 'none',
                            objectFit: 'contain',
                        }}
                    />
                </div>

            </div>

            {showBuffet && <BuffetScreen setShowBuffet={setShowBuffet} />}
            {showCumple && <CumpleScreen setShowBuffet={setShowCumple} />}
            {showHome && <HomeScreen setShowBar={setShowBar} />}
            </LayoutContent>

    );
}

export default Index;
